import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface InvoicingSettingsMonthDto {
  year: number;
  month: number; // 1..12
  forecastMonths: number;
  closingMonths: number;
  regenerateMonths: number;
  active?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class InvoicingSettingsApiService {
  constructor(private readonly http: HttpClient) {}

  getYear(year?: number): Observable<InvoicingSettingsMonthDto[]> {
    let params = new HttpParams();
    if (year != null) {
      params = params.set('year', String(year));
    }
    return this.http.get<InvoicingSettingsMonthDto[]>(
      `${environment.apiUrl}/configuration/invoicing-settings`,
      { params },
    );
  }

  upsertYear(year: number, rows: InvoicingSettingsMonthDto[]): Observable<InvoicingSettingsMonthDto[]> {
    const params = new HttpParams().set('year', String(year));
    return this.http.put<InvoicingSettingsMonthDto[]>(
      `${environment.apiUrl}/configuration/invoicing-settings`,
      rows,
      { params },
    );
  }
}

